export const initState = {
    currency: "$",
    currencyObject: {USD: {Value: 75.0}, EUR: {Value: 80.0}, TRY: {Value: 39.0}},
    languge: "rus",
    page: "rent",
    pageParam: "",
    fullDataBase: "",
    usersDataBase: "",
    regions: "",
    chosenObject: "",
    sorterValue: "sort",
    mainSearchInput: {"inputState":"rent", "inputCountry":"flat"},
    searchInput: {
      globalSearchInput:"",
      inputCity:"",
      inputDistrict:"",
      minPrice:-Infinity,
      maxPrice:+Infinity,
      minSqure:-Infinity,
      maxSqure:+Infinity,
      '1+1':false,
      '2+1':false,
      '3+1':false,
      heatingNo:"",
      heatingGas:"",
      heatingElectro:"",
      airYes:true,
      airNo:false,
      bath0:false,
      bath1:false,
      bath2:false,
      bath3:false,
      bath4:false,
      balkony0:false,
      balkony1:false,
      balkony2:false,
      balkony3:false,
      balkony4:false,
      balkony5:false,
      furnitureYes:false,
      furnitureNo:false,
      kitchenYes:false,
      kitchenNo:false 
    },
    agreementValue: false,
  }

